<template>
	<div id="app" ref="app">
		<div v-if="isPreviewPage" class="preview">内部链接 请勿分享给机构外部人员使用</div>
		<router-view></router-view>
	</div>
</template>

<script>
import { mapActions } from 'vuex'
import api from 'src/constants/appapi'
export default {
	name: 'app',
	data(){
		return {
			isPreviewPage:false
		}
	},
	created() {
		window.appapi = api
    window.$vm = this
    this.isPreviewPage = appapi.isPreviewPage()
	},
	mounted() {
		// 预览宽度
		if( this.$route.query.preview
			  && !navigator.userAgent.match(/Android/i)
        && !navigator.userAgent.match(/webOS/i)
        && !navigator.userAgent.match(/iPhone/i)
        && !navigator.userAgent.match(/iPad/i)
        && !navigator.userAgent.match(/iPod/i)
        && !navigator.userAgent.match(/BlackBerry/i)
        && !navigator.userAgent.match(/Windows Phone/i)
    ){
			$('html').css({'max-width': '375px','font-size': '37.5px'})

		}

		const appW = this.$refs.app.offsetWidth;
		this.updateWidth(appW);
	},
	methods: {
		...mapActions({
			updateWidth: 'app:update:width'
		})
	}
}
</script>
<style lang="stylus" scoped>
.preview
	color red
	font-weight bold
	text-align center
	font-size 36px
	line-height 72px
</style>



// WEBPACK FOOTER //
// App.vue?5450a8e4